import { Mapper } from '../../../../base/utils/mapper';
import { RoutesAdministrationModel } from '../../../../domain/models/consult/routes-administration.model';
import { RoutesAdministrationEntity } from '../entities/routes-administration.entity';

export class RoutesAministrationImplementationRepositoryMapper extends Mapper<RoutesAdministrationEntity, RoutesAdministrationModel> {
    mapFrom(param: RoutesAdministrationEntity): RoutesAdministrationModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: RoutesAdministrationModel): RoutesAdministrationEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}